// extracted by mini-css-extract-plugin
export default {"photo":"RateButton_photo__eqYVE","btn":"RateButton_btn__QCy1V","content":"RateButton_content__IPRyP"};